import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './AccordionContent.scss';

interface AccordionContentProps {
  items?: MenuItem[];
  isClosing?: boolean;
  onAnimationEnd?: () => void;
  onButtonClick?: (index: number, name: string) => void;
  onLinkClick?: (name: string) => void;
}

export const AccordionContent: FC<AccordionContentProps> = ({
  items,
  isClosing = false,
  onAnimationEnd = () => {},
  onButtonClick = () => {},
  onLinkClick = () => {},
}) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      data-testid="accordion-menu-content"
      className={classNames(styles.accordionContent, {
        [styles.closing]: isClosing,
      })}
      onAnimationEnd={isClosing ? onAnimationEnd : null}
    >
      <ul className={styles.accordionContentList}>
        {items.map((item, index) => {
          if (item?.child?.length > 0) {
            return (
              <li key={item.id}>
                <button
                  className={classNames(styles.accordionLink)}
                  onClick={() => onButtonClick(index, item.name)}
                >
                  {item.name}
                </button>
              </li>
            );
          }

          return (
            <li key={item.id}>
              <a
                onClick={() => onLinkClick(item.name)}
                className={classNames(styles.accordionLink)}
                href={item.url}
              >
                {item.name}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
